import { CreateZendeskTicketV2 } from '@apis/requests/zendesk-v2/create-ticket-v2';
import useRequest from '@hooks/useRequest';

export default function useZendesk() {
    const api = useRequest('zendesk');

    async function createTicketV2(data: CreateZendeskTicketV2) {
        const request = new FormData();
        request.append('name', data.name);
        request.append('email', data.email);
        request.append('subject', data.subject);
        request.append('description', data.description);
        request.append('file', data.file as File);
        request.append('pageSelection', data.pageSelection as string); 
        request.append('persistenceSelection', data.persistenceSelection as string);
        request.append('pageURL', data.pageURL as string);

        return api.post('v2/ticket', request);
    }
 
    return { createTicketV2 };
}
